<template lang="pug">
  v-row.ma-0.mt-3(v-if="value.length > 0")
    v-col.pa-0(cols="12")
      v-card.elevation-0.card-style
        v-row.ma-0(dense)
          v-col.text-start.pa-0.pt-2(cols="12" )
            v-icon.pl-md-3.pb-3 {{getIcon}}
            span.pa-0.font-weight-bold.text-h5.grey--text.text--darken-2.pl-2 {{groupName}}
        v-row.ma-0
          v-col.pa-0.pr-md-3.pl-md-3.mb-1(cols="12" v-for="(item, idx) in orderedValue" :key="idx")
            v-card-text.pa-0.border-component(v-if="item.value > 0")
                v-row.ma-0.border-component(no-gutters)
                  v-col.d-flex.flex-column
                    v-row.ma-0
                      v-col.text-start.text-h5.text-style.pl-3.py-0.font-weight-bold.pt-1(cols="12") {{item.title}}
                    v-row.ma-0
                      v-col.text-start.text-wrap.subtitle-1.py-0.text-style(cols="12") {{item.food}}
                  v-col.style.border-col-component(:style="{'background-color' : getTotalSummaryColor(item)}")
                    v-row.ma-0.fill-height(justify="center" align="center" )
                      v-col.text-center.text-h5.pr-2.py-0(cols="12" :style="{'color' : getTotalSummaryTextColor(item)}") {{item.value}}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import moment from "moment/moment";
import _ from "lodash";

@Component
export default class DashboardReservationSummaryItemDetail extends Vue {

    @Prop({ type: String, required: true }) readonly groupName!: string
    @Prop({type: Array, required: false}) value!: any
    @Prop({type: String, required: false}) date!: string


    get orderedValue (): any {
      return _.orderBy(this.value, 'order')
    }

    getTotalSummaryColor (item: any) {
        if(item.totalPortion > item.value) {
            return '#81ccc5'
        } else {
            return '#B71C1C'
        }
    }

    getTotalSummaryTextColor(item: any) {
        if(item.totalPortion > item.value) {
            return '#000000'
        } else {
            return '#FFFFFF'
        }
    }

    get getCardStyle (): string {
        if(this.date && this.date === moment().format('YYYY-MM-DD')) {
            return '#E0F2F1'
        } else {
            return '#f3efef'
        }
    }

    get getIcon (): string  {
        let icon: string = ''
        this.value.forEach((item: any) => {
            icon = `fas ${item.icon}`
        })
        return icon

    }

    mounted () {
    }
}
</script>

<style lang="stylus" scoped>
  .card-style
    background-color #e5e5ee
  .style
    max-width 70px
  .text-style
    background-color white
  .border-component
    border white solid
    border-bottom-right-radius 10px
    border-bottom-left-radius 10px
    border-top-left-radius 10px
    border-top-right-radius 10px
    background-color white
  .border-col-component
    border-bottom-right-radius 10px
    border-bottom-left-radius 10px
    border-top-left-radius 10px
    border-top-right-radius 10px


</style>